import { Injectable } from '@angular/core';

import { AOContainerDirective } from './ao-container.directive';

@Injectable({
  providedIn: 'root'
})
export class AOContainerService {

  private _directive: AOContainerDirective;

  constructor() {
  }

  init(directive: AOContainerDirective) {
    this._directive = directive;
    return this;
  }

  open(component: any, data: any = {}) {
    const instance = this._directive.open(component);

    instance.data = data;

    return this;
  }

  close() {
    this._directive.clear();
    return this;
  }

}
